import * as z from 'zod';
import { candidateFormSchema } from '../../shared/candidate-form-schema';

export const offerFormSchema = candidateFormSchema.extend({
  HiringDepartmentId: z.string().min(1, { message: 'DEPARTMENT_REQUIRED' }),
});

export type OfferFormValues = z.infer<typeof offerFormSchema>;
